import { Email, Facebook, GitHub, Home, Instagram, LinkedIn, Phone } from '@mui/icons-material';
import logo from '../../assets/logo.svg'
import {
    Link
} from "react-router-dom";

const Footer = () => {
    return (
        <>
            <footer className="text-center bg-light text-lg-start text-muted">
                {/* <section
                    className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom social-links"
                >
                    <div className="me-5 d-none d-lg-block" data-aos="fade-right"
                        data-aos-duration="800">
                        <span>Get connected with us on social networks:</span>
                    </div>
                    <div>
                        <a href="https://www.facebook.com/ashirvad.tidake" target="_bluecoder" className="me-4 text-reset">
                            <Facebook data-aos="zoom-in"
                                data-aos-duration="1000" />
                        </a>
                        <a href="https://www.instagram.com/ashirvadtidake/" target="_bluecoder" className="me-4 text-reset">
                            <Instagram data-aos="zoom-in"
                                data-aos-delay="200"
                                data-aos-duration="1000" />
                        </a>
                        <a href="https://www.linkedin.com/in/pravin-tidake-6a730118b/" target="_bluecoder" className="me-4 text-reset">
                            <LinkedIn data-aos="zoom-in"
                                data-aos-delay="400"
                                data-aos-duration="1000" />
                        </a>
                        <a href="https://github.com/pravintidake" target="_bluecoder" className="me-4 text-reset">
                            <GitHub data-aos="zoom-in"
                                data-aos-delay="600"
                                data-aos-duration="1000" />
                        </a>
                    </div>
                </section> */}

                <section>
                    <div className="container text-center text-md-start mt-5">
                        <div className="footer-row row mt-3">
                            <div className="col-md-11 col-lg-4 col-xl-4 mb-4"
                                data-aos="fade-right"
                                data-aos-delay="300"
                                data-aos-duration="1000">
                                <Link to="/">
                                    <img height="auto" width="auto" loading="lazy" className="mb-3" src={logo} alt="Bluecoder footer logo" title="Bluecoder footer logo" />
                                </Link>
                                <p className="text-primary footer-desc">
                                    We help enhance your business and brand’s visibility by taking it to an online business platform.
                                </p>
                            </div>

                            <div className="col-md-6 px-auto col-lg-3 col-xl-3 mx-auto mb-4"
                                data-aos="fade-down"
                                data-aos-delay="300"
                                data-aos-duration="1000">
                                <Link to="/services"><h3 className="footer-header contact-text text-uppercase text-primary fw-bold mb-4">
                                    Services
                                </h3></Link>
                                <p>
                                    <Link to="/services" className="text-primary text-decoration-none footer-links">Web Design & Devlopment</Link>
                                </p>
                                <p>
                                    <Link to="/services" className="text-primary text-decoration-none footer-links">Mobile App Devlopment</Link>
                                </p>
                                <p>
                                    <Link to="/services" className="text-primary text-decoration-none footer-links">Digital Marketing</Link>
                                </p>
                                <p>
                                    <Link to="/services" className="text-primary text-decoration-none footer-links">E-Commerce Devlopment</Link>
                                </p>
                                <p>
                                    <Link to="/services" className="text-primary text-decoration-none footer-links">SEO & SMM</Link>
                                </p>
                            </div>

                            <div className="col-md-4 px-auto col-lg-2 col-xl-2 mx-auto mb-4"
                                data-aos="fade-down"
                                data-aos-delay="300"
                                data-aos-duration="1000">

                                <h3 className="footer-header contact-text text-uppercase text-primary fw-bold mb-4">
                                    Useful links
                                </h3>
                                <p>
                                    <Link to="/" className="text-primary text-decoration-none footer-links">Home</Link>
                                </p>
                                <p>
                                    <Link to="/about" className="text-primary text-decoration-none footer-links">About Us</Link>
                                </p>
                                <p>
                                    <Link to="/services" className="text-primary text-decoration-none footer-links">Services</Link>
                                </p>
                                <p>
                                    <Link to="/pricing" className="text-primary text-decoration-none footer-links">Pricing</Link>
                                </p>
                                <p>
                                    <Link to="/contact" className="text-primary text-decoration-none footer-links">Contact</Link>
                                </p>

                            </div>

                            <div className="col-md-11 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4"
                                data-aos="fade-left"
                                data-aos-delay="300"
                                data-aos-duration="1000">

                                <h3 className="footer-header contact-text text-uppercase text-primary fw-bold mb-4">
                                    Contact
                                </h3>
                                <p className="text-primary"> <Home className="me-2 footer-icons" /> Trimurti Nagar, Nagpur, Maharashtra - 440022</p>
                                <p>
                                    <a href="mailto:ashirvadtidake@gmail.com" target="_bluecoder" className="text-primary text-decoration-none footer-links">  <Email className="me-3 footer-icons" />
                                        bluecodertech@gmail.com </a>

                                </p>
                                {/* <p><a href="tel:+917769864038" target="_bluecoder" className="text-primary footer-links text-decoration-none"> <Phone className="me-3 footer-icons" />+917769864038 </a></p> */}
                            </div>

                        </div>

                    </div>
                </section>

                <div className="text-center text-white p-4 bg-primary">
                    © 2022 Copyright
                    <Link className="text-white text-decoration-none" to="/"> Bluecoder</Link>.
                    All Rights Reserved | <Link className="text-white text-decoration-none" to="/"
                    >Terms & Conditions</Link>
                </div>

            </footer>
        </>
    )
}

export default Footer